  <app-navigation></app-navigation> 
 
   <app-search-box mode="1"></app-search-box>

   <div class="container bg-white">
    <table class="table table-bordered table-hover bg-white">
      <thead class="thead-light" >
        <tr>
          <th scope="col">Name</th>
          <th scope="col">City</th>
          <th scope="col">State</th>
          <th scope="col">Specialty</th>
          <th scope="col">Hourly</th>
          <th scope="col">Since</th>
          <th scope="col"><input type="checkbox" name="selectall" id="selectall" (click)="checkAll()"></th>
        </tr>
       
      </thead>
      <tbody *ngIf="proffesionals">
        <tr *ngFor="let item of proffesionals">
          <th scope="row"><a href="javascript:void" routerLink="/prodetail/{{item.PkProffesional}}">{{item.FirstName}} {{item.Middlename}} {{item.LastName}}</a></th>
          <td>{{item.City}}</td>
          <td>{{item.State}}</td>
          <td>{{item.SpecialtyName}}</td>
          <td>${{item.HourlyRate}}</td>
          <td>{{item.Experience}}</td>
          <td><input type="checkbox" [name]="item.PkProffesional" [id]="item.PkProffesional"></td>
        </tr>
         <tr *ngIf="proffesionals.length<1"><td colspan="4">No professionals found</td></tr>
      </tbody>
    </table>
    <div class="d-flex w-100 justify-content-end">
      <span class="h5">{{totalSearchResult}} entries</span>&nbsp;&nbsp;
      <button *ngIf="user.isAdmin"  class="btn btn-outline-secondary" (click)="addToList()">Add to list</button>
    </div>
  <nav aria-label="..." *ngIf="!usingLetterPaging">
    <ul class="pagination pagination-md">
      <li *ngFor="let item of pages"  [class]="(item==currentPage)?'page-item disabled':'page-item'"><a href="javascript:void(0)" class="page-link" (click)="loadPage(item)">{{item}}</a></li>
    </ul>
  </nav>
  <hr>
   <nav aria-label="...">
    <ul class="pagination pagination-md">
      <li *ngFor="let item of letters"  [class]="(item==currentLetterPage)?'page-item disabled':'page-item'"><a href="javascript:void(0)" class="page-link" (click)="filterPage(item)">{{item}}</a></li>
    </ul>
  </nav>
  <br>
</div>
<app-footer></app-footer>

<ng-template #content let-modal>
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Select list</h5>
        <button type="button" class="close" (click)="auxModal.close()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        <label for="listname">List name</label>&nbsp;&nbsp;
        <select name="listname" id="listname" [(ngModel)]="listname">
          <option *ngFor="let item of adminLists" [value]="item.value">{{item.label}}</option>
        </select>
        <p><span text="text-center">{{profSel}} entries selected</span></p>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" (click)="auxModal.close()">Close</button>
        <button type="button" class="btn btn-primary" (click)="saveToList()">Save</button>
      </div>
</ng-template>
